import { Box, Divider, Grid2 as Grid, Paper, Stack, Typography } from "@mui/material";
import RecyclingIcon from "@mui/icons-material/Recycling";
import OrganicMaterialsChart from "./chart/sensors/organicMaterials";
import QuantityMaterialPerMonth from "./chart/sensors/quantityMaterialPerMonth";
import RecyclingRateQuarterChart from "./chart/sensors/recyclingRateQuarter";
import CropCosts from "./chart/sensors/cropCosts";
import QuantityPerFloor from "./chart/sensors/quantityPerFloor";
import QuantityPerMonth from "./chart/sensors/quantityPerMonth";
import { ReactNode, useEffect, useState } from "react";
import ITrash from "../../models/garbage can/response/trash";
import SensorService from "../../services/sensor/SensorService";
import auth from "../../services/auth/AuthService";
import AuthService from "../../services/auth/AuthService";

interface CardWasteProps {
    title: string;
    value: number;
    icon: ReactNode;
}
const WasteCard = ({ title, value, icon }: CardWasteProps) => {
    return (
        <Paper style={{ width: "100%", height: "100%" }}>
            <Box padding={1} paddingLeft={2}>
                <Stack direction="row" alignItems="center" gap={1}>
                    {icon}
                    <Typography>{title}</Typography>
                </Stack>
                <Divider sx={{ marginTop: 1 }} />
                <Typography sx={{ marginTop: 1 }}>
                    {value} Cubic metre
                </Typography>
            </Box>
        </Paper>
    );
};

interface StatCardProps {
    title: string;
    children: ReactNode;
}
const StatCard = ({ title, children }: StatCardProps) => {
    return (
        <Paper style={{ width: "100%", height: "100%" }}>
            <Box padding={2}>
                {title}
                <Divider sx={{ marginTop: 1 }} />
                {children}
            </Box>
        </Paper>
    );
};
const WasteCanDashboardPage = () => {
    const [trash, setTrashe] = useState<ITrash>();
    const [quantityPerMonth, setQuantityPerMonth] = useState<
        Map<string, number>
    >(new Map());
    const [residualMaterial, setResidualMaterial] = useState<
        Map<string, number>
    >(new Map());

    useEffect(() => {
        const fetchQuantityPerMonth = async () => {
            const userCompanyId = AuthService.user?.companyId || 0;
            const startDate = new Date();
            const endDate = new Date();

            return await SensorService.GetQuantityPerMonth(
                userCompanyId,
                startDate,
                endDate
            );
        };
        fetchQuantityPerMonth().then(setQuantityPerMonth);

        const fetchResidualMaterialPerMonth = async () => {
            const userCompanyId = AuthService.user?.companyId || 0;
            const startDate = new Date();
            const endDate = new Date();

            return await SensorService.GetResidualMaterialPerMonth(
                userCompanyId,
                startDate,
                endDate
            );
        };

        fetchResidualMaterialPerMonth().then(setResidualMaterial);

        SensorService.GetTotalResidualMaterial(
            auth.user?.companyId || 0,
            new Date(),
            new Date()
        ).then(setTrashe);
    }, []);
    return (
        <Box>
            <Grid container spacing={3} width={"100%"}>
                <Grid size={{ sm: 3, xs: 12 }}>
                    <WasteCard
                        title="Matières résiduelles totale"
                        value={trash?.total || 0}
                        icon={<RecyclingIcon />}
                    />
                </Grid>
                <Grid size={{ sm: 3, xs: 12 }}>
                    <WasteCard
                        title="Waste"
                        value={trash?.waste || 0}
                        icon={<RecyclingIcon />}
                    />
                </Grid>
                <Grid size={{ sm: 3, xs: 12 }}>
                    <WasteCard
                        title="Recycling"
                        value={trash?.recycling || 0}
                        icon={<RecyclingIcon />}
                    />
                </Grid>
                <Grid size={{ sm: 3, xs: 12 }}>
                    <WasteCard
                        title="Compost"
                        value={trash?.compost || 0}
                        icon={<RecyclingIcon />}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={3} marginTop={1} width="100%">
                <Grid size={{ sm: 3, xs: 12 }}>
                    <StatCard title="Repair of materials">
                        <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            justifyContent="center"
                            height="100%"
                            marginTop={7}
                        >
                            {trash && <OrganicMaterialsChart trash={trash} />}
                        </Box>
                    </StatCard>
                </Grid>
                <Grid size={{ sm: 4.5, xs: 12 }}>
                    <StatCard title="Quantity of materials collected per month">
                        <QuantityMaterialPerMonth />
                    </StatCard>
                </Grid>
                <Grid size={{ sm: 4.5, xs: 12 }}>
                    <StatCard title="Harvest costs">
                        {residualMaterial && (
                            <CropCosts residualMaterial={residualMaterial} />
                        )}
                    </StatCard>
                </Grid>
                <Grid size={{ sm: 3, xs: 12 }}>
                    <StatCard title="Recycling rate by quartile">
                        {quantityPerMonth && (
                            <RecyclingRateQuarterChart
                                quantityPerMonth={quantityPerMonth}
                            />
                        )}
                    </StatCard>
                </Grid>
                <Grid size={{ sm: 4.5, xs: 12 }}>
                    <StatCard title="Quantity per floor">
                        <QuantityPerFloor />
                    </StatCard>
                </Grid>
                <Grid size={{ sm: 4.5, xs: 12 }}>
                    <StatCard title="Quantity per month">
                        {quantityPerMonth && (
                            <QuantityPerMonth
                                quantityPerMonth={quantityPerMonth}
                            />
                        )}
                    </StatCard>
                </Grid>
            </Grid>
        </Box>
    );
};

export default WasteCanDashboardPage;